import { useState } from 'react';
import { IconButton, Typography, MenuItem, Menu } from '@mui/material';
import MoreIcon from 'src/global/assets/images/more.png';

import { styles } from './styles';

interface Props {
  /** El drawer es owned por ItemTransaction (H5: la fila también lo abre). */
  onOpenDetail: () => void;
}

function MenuActionsTransaction({ onOpenDetail }: Readonly<Props>) {
  const { classes } = styles();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    // No abrir el drawer por el click de fila cuando se abre el menú.
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpenDetail = (event: React.MouseEvent) => {
    event.stopPropagation();
    handleClose();
    onOpenDetail();
  };

  return (
    <>
      <IconButton className={classes.wrapperIcon} aria-label="more" id="long-button" onClick={handleClick}>
        <img src={MoreIcon} alt="more" className={classes.moreIcon} />
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          'aria-labelledby': 'long-button'
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}>
        <MenuItem>
          <Typography onMouseDown={handleClose} onClick={handleOpenDetail} className={classes.buttonLabel}>
            Ver detalle
          </Typography>
        </MenuItem>
      </Menu>
    </>
  );
}

export default MenuActionsTransaction;
